import styled from "styled-components";

export const EditorBlockWrapper = styled.div<{buttonName: string, disableButton: boolean}>`
  button[data-cke-tooltip-text="${({buttonName}) => (buttonName)}"] {
    cursor: ${({disableButton}) => disableButton ? 'not-allowed' : 'pointer'};
    pointer-events: ${({disableButton}) => disableButton ? 'none' : 'auto'};
    opacity: ${({disableButton}) => disableButton ? '0.5' : '1'};
  }
`;
